import { loan360Path } from '../../utils/loanNavigation';

/** The private credit home: a segmented control over Overview (the board) / Facilities / Work queue. */
export const PC_HOME_PATH = '/portfolio-management/credit/private-credit';
/** F-PCP-019: the home lives inside the Portfolio Management hub (left navigation intact); the bare route stays for old links. */
export const PC_HUB_PATH = '/portfolio-management?tab=alternatives&sub=private-credit';
export type PcHomeView = 'overview' | 'facilities' | 'queue';
export const pcHomePath = (view: PcHomeView = 'overview') =>
  view === 'overview' ? PC_HUB_PATH : `${PC_HUB_PATH}&view=${view}`;

export const PC_QUEUE_PATH = `${PC_HOME_PATH}/queue`;

/** Where a credit agreement PDF is uploaded (Document Processing, with the type preselected). */
export const PC_DOCUMENT_ENTRY = '/middle-office?tab=document-processing&documentType=CREDIT_AGREEMENT';
/** Where a facility is typed in (the credit loan reference workspace, new private credit loan). */
export const PC_MANUAL_ENTRY = '/reference-data?tab=credit-loans&assetClass=PRIVATE_CREDIT&new=1';

/** A queue item's next action, as a Loan 360 address. The workspaces are the loan page's tabs. */
export const pcActionPath = (loanId: number, workspace: string, query?: string | null): string => {
  if (workspace === 'ticket') {
    return query && query.startsWith('tradeId=') ? `/bond-transactions?${new URLSearchParams({ query: query.slice('tradeId='.length) })}` : loan360Path('PRIVATE_CREDIT', loanId);
  }
  if (workspace === 'documents') return loan360Path('PRIVATE_CREDIT', loanId);
  const tab = ['overview', 'underwriting', 'covenants', 'lme', 'workout', 'exceptions'].includes(workspace) ? workspace : 'overview';
  const base = loan360Path('PRIVATE_CREDIT', loanId, tab);
  return query ? `${base}${base.includes('?') ? '&' : '?'}${query}` : base;
};
